import React, { FC, SVGAttributes } from "react"
import SVG from "./svg"

const ArrowBoost: FC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <SVG
      viewBox="0 0 29 35"
      {...props}
    >
      <path
        d="M0 14.142L14.142 0l14.142 14.142H19V23H9v-8.858H0zM19 25H9v4h10v-4zM19 31H9v4h10v-4z"
      ></path>
    </SVG>
  )
}

export default ArrowBoost
